import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { newDossierValue } from '../redux/actions/devisActions';

const NumsDoss = () => {
  const dispatch = useDispatch();
  const dossierValue = useSelector((state) => state.devis.dossierValue);
  const dossier = useSelector((state) => state.dossier.items);

  const handleDossierChange = (event) => {
    dispatch(newDossierValue(event.target.value));
  };

  return (
    <div className="ndossier">
      <label>N° Dossier : </label>
      <select
        id="lang"
        onChange={handleDossierChange}
        value={dossierValue}
      >
        {dossier.map(({ ndossier }, i) => (
          <option key={i} value={ndossier}>
            {ndossier}
          </option>
        ))}
      </select>
    </div>
  );
};

export default NumsDoss;